<script>
	// 타임라인 데이터
	const experiences = [
		{
			title: "Freelance Web Developer",
			company: "Self-employed",
			period: "2024 - Present",
			description: "Designing and developing responsive websites for small businesses and individuals. Creating custom web solutions based on client requirements and implementing modern web technologies.",
			responsibilities: [
				"Front-end development using HTML, CSS, JavaScript, and modern frameworks",
				"Working directly with clients to gather requirements and deliver solutions",
				"Maintaining and updating existing websites",
				"Ensuring responsive design and cross-browser compatibility"
			]
		},
		{
			title: "Web Development Intern",
			company: "Start-up Company",
			period: "2025",
			description: "Assisted in developing and maintaining web applications for various clients. Collaborated with senior developers to implement new features and fix bugs.",
			responsibilities: [
				"Helped build responsive UI components using Svelte and TypeScript",
				"Participated in code reviews and team meetings",
				"Tested applications across different browsers and devices",
				"Documented code and features for team reference"
			]
		}
	];
</script>

<div class="career-container">
	<h1>Career</h1>
	
	<div class="timeline">
		{#each experiences as experience, index}
			<div class="timeline-item">
				<div class="timeline-dot"></div>
				<div class="timeline-content">
					<div class="experience-header">
						<h2>{experience.title}</h2>
						<p class="company">{experience.company}</p>
						<p class="period">{experience.period}</p>
					</div>
					
					<p class="description">{experience.description}</p>
					
					<div class="responsibilities">
						<h3>Key Responsibilities:</h3>
						<ul>
							{#each experience.responsibilities as responsibility}
								<li>{responsibility}</li>
							{/each}
						</ul>
					</div>
				</div>
			</div>
			
			{#if index < experiences.length - 1}
				<div class="timeline-connector"></div>
			{/if}
		{/each}
	</div>
	
	<div class="skills-section">
		<h2>Professional Skills</h2>
		
		<div class="skills-categories">
			<div class="skills-category">
				<h3>Technical Skills</h3>
				<div class="skills-list">
					<span>Web Development</span>
					<span>UI/UX Design</span>
					<span>Mobile-first Development</span>
					<span>API Integration</span>
					<span>Version Control</span>
				</div>
			</div>
			
			<div class="skills-category">
				<h3>Soft Skills</h3>
				<div class="skills-list">
					<span>Problem Solving</span>
					<span>Communication</span>
					<span>Time Management</span>
					<span>Team Collaboration</span>
					<span>Client Relations</span>
				</div>
			</div>
		</div>
	</div>
</div>

<style>
	.career-container {
		max-width: 800px;
		margin: 80px auto 0;
		padding: 0 20px;
	}

	h1 {
		font-size: var(--font-size-title, 2rem);
		margin-bottom: 1.5rem;
		color: var(--color-text, #000000);
	}
	
	.timeline {
		position: relative;
		margin: 2rem 0 4rem;
	}
	
	.timeline-item {
		position: relative;
		padding-left: 2.5rem;
		margin-bottom: 1rem;
	}
	
	.timeline-dot {
		position: absolute;
		left: 0;
		top: 0.5rem;
		width: 16px;
		height: 16px;
		background-color: #000;
		border-radius: 50%;
		z-index: 2;
	}
	
	.timeline-connector {
		position: relative;
		left: 7px;
		height: 40px;
		width: 2px;
		background-color: #000000;
		margin-bottom: 1rem;
	}
	
	.timeline-content {
		padding: 1rem 1.5rem;
		border-left: 1px solid rgb(255, 255, 255)	}
	
	.experience-header {
		margin-bottom: 1rem;
	}
	
	h2 {
		margin: 0 0 0.5rem 0;
		font-size: 1.5rem;
		border-bottom: 1px solid #eee;
		padding-bottom: 0.5rem;
	}
	
	.company {
		font-weight: bold;
		margin: 0 0 0.2rem 0;
	}
	
	.period {
		color: #a1a1a1;
		margin: 0;
		font-size: 0.9rem;
	}
	
	.description {
		margin: 0 0 1rem 0;
	}
	
	.responsibilities h3 {
		font-size: 1.1rem;
		margin: 0 0 0.5rem 0;
	}
	
	.responsibilities ul {
		margin: 0;
		padding-left: 1.5rem;
	}
	
	.responsibilities li {
		margin-bottom: 0.5rem;
	}
	
	.skills-section {
		margin-top: 3rem;
	}
	
	.skills-categories {
		display: flex;
		flex-wrap: wrap;
		gap: 2rem;
	}
	
	.skills-category {
		flex: 1;
		min-width: 250px;
	}
	
	.skills-category h3 {
		font-size: 1.2rem;
		margin: 0 0 1rem 0;
	}
	
	.skills-list {
		display: flex;
		flex-wrap: wrap;
		gap: 0.8rem;
	}
	
	.skills-list span {
		background-color: #383838;
		color: white;
		padding: 0.5rem 1rem;
		border-radius: 10px;
		font-size: 0.9rem;
	}
	
	/* 반응형 디자인 */
	@media (max-width: 768px) {
		.timeline-content {
			padding: 1rem;
		}
		
		.skills-category {
			min-width: 100%;
		}
	}
</style>